import { Helmet } from 'react-helmet-async';
import "./CommunityPage.css"
import communityImg from "../../assets/AboutCommunity.jpg"

const CommunityPage = () => {
  return (
    <div className="comm-page">
      <Helmet>
        <title>Join the Community | QuantumKE</title>
        <meta name="description" content="Join QuantumKE's growing community of quantum enthusiasts. Connect on GitHub and WhatsApp, access resources, and collaborate with researchers and innovators across Kenya and Africa." />
        <link rel="canonical" href="https://quantumke.org/join-community" />
      </Helmet>

      {/* ── HERO ── */}
      <section className="comm-hero">
        <div className="comm-container">
          <h1 className="comm-hero-title">Join the Community</h1>
          <p className="comm-hero-desc">
            Our community brings together researchers, industry experts, academics, and enthusiasts
            passionate about advancing quantum technology and its applications across various fields.
          </p>
        </div>
        <div className="comm-hero-img-wrap">
          <img src={communityImg} alt="QuantumKE Community" className="comm-hero-img" />
          <div className="comm-hero-img-overlay" />
        </div>
      </section>

      {/* ── CONNECT ── */}
      <section className="comm-connect">
        <div className="comm-container">
          <div className="comm-connect-header">
            <span className="comm-label">Connect With Us</span>
            <h2 className="comm-connect-title">Find Your Space in the Community</h2>
            <p className="comm-connect-desc">
              Whether you prefer open-source collaboration or real-time conversation, we are
              active on the platforms where you already are.
            </p>
          </div>

          <div className="comm-social-grid">
            {/* GitHub */}
            <a
              href="https://github.com/quantumke-org"
              target="_blank"
              rel="noopener noreferrer"
              className="comm-social-card comm-social-github"
            >
              <div className="comm-social-card-top">
                <div className="comm-social-icon-wrap">
                  <svg fill="currentColor" viewBox="0 0 24 24" className="comm-social-svg">
                    <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
                  </svg>
                </div>
                <span className="comm-social-platform">GitHub</span>
              </div>
              <h3 className="comm-social-name">Open-Source Projects</h3>
              <p className="comm-social-blurb">
                Explore our repositories, contribute to quantum tools, and collaborate with
                developers building the open-source quantum ecosystem.
              </p>
              <span className="comm-social-cta">
                Visit GitHub
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
            </a>

            {/* WhatsApp */}
            <a
              href="https://chat.whatsapp.com/JKgkJRJNYV9L9mqJkSxgcb"
              target="_blank"
              rel="noopener noreferrer"
              className="comm-social-card comm-social-whatsapp"
            >
              <div className="comm-social-card-top">
                <div className="comm-social-icon-wrap">
                  <svg fill="currentColor" viewBox="0 0 24 24" className="comm-social-svg">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488z" />
                  </svg>
                </div>
                <span className="comm-social-platform">WhatsApp</span>
              </div>
              <h3 className="comm-social-name">Community Group</h3>
              <p className="comm-social-blurb">
                Join the conversation in our active WhatsApp group — share ideas, ask questions,
                get updates, and connect with fellow quantum enthusiasts in real time.
              </p>
              <span className="comm-social-cta">
                Join Group
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
            </a>
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="comm-cta">
        <div className="comm-container">
          <div className="comm-cta-card">
            <div className="comm-cta-glow" aria-hidden />
            <div className="comm-cta-inner">
              <h2 className="comm-cta-title">
                Join us as we build the future of quantum computing
              </h2>
              <p className="comm-cta-desc">
                Be part of a growing community pushing the boundaries of what is possible with
                quantum technology.
              </p>
              <a
                href="https://forms.gle/zzo6uDkMy3EL8NZs6"
                target="_blank"
                rel="noopener noreferrer"
                className="comm-cta-btn"
              >
                Sign Up to Join
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path d="M3.75 9h10.5M10 5l4 4-4 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </section>

    </div>
  )
}

export default CommunityPage
